export enum ErrorType {
  BEHOERDENCLIENT_PROBLEMS_MANDANT_CONFLICT = 'behoerdenclient/problems/mandantConflict',
  CONSTRAINT_VIOLATION = 'https://zalando.github.io/problem/constraint-violation',
  BEHOERDENCLIENT_PROBLEMS_USER_CONFLICT = 'behoerdenclient/problems/userConflict',
  BEHOERDENCLIENT_PROBLEMS_USER_CANNOT_BE_DELETED = 'behoerdenclient/problems/userCannotBeDeleted'
}

export enum ReasonType {
  BEHOERDENCLIENT_REASONS_USER_HAS_CASES = 'userHasCases',
  BEHOERDENCLIENT_REASONS_USER_IS_ONLY_ADMIN = 'userIsOnlyAdmin'
}

export interface ReasonsType {
  type: ReasonType;
}

export enum ERROR_CASE_CLIENT {
  NOT_AUTHORIZED
}

const errorMsgBackend =
  'Bitte wenden Sie sich mit folgendem Error-Code an Ihren Administrator.';

const errorMsgClient = 'Bitte wenden Sie sich an Ihren Administrator';

export const conflictErrorMsg =
  'Das Objekt wurde seit dem Laden verändert. Bitte führen Sie die Aktion erneut durch.';

export const fjdAlertErrorClientMsg = `Es ist ein Fehler aufgetreten. ${errorMsgClient}`;

const error_NotAuthorized = `${fjdAlertErrorClientMsg} (Kein Zugriff).`;

export function getErrorMsgClient(errorCase: ERROR_CASE_CLIENT): string {
  switch (errorCase) {
    case ERROR_CASE_CLIENT.NOT_AUTHORIZED:
      return error_NotAuthorized;
    default:
      return `${fjdAlertErrorClientMsg}.`;
  }
}
